import { SEARCH_MIN_CHARS } from "src/constants";

/**
 * Shown under a link picker's search field until enough is typed to search:
 * the hashtag picker and every SearchPicker (page, news, event, form) share
 * this one hint.
 */
const SearchMinCharsHint = ({ id }: { id?: string }) => (
	<p id={id} className="text-caption text-muted-foreground">
		Start typing to search — minimum {SEARCH_MIN_CHARS} characters.
	</p>
);

export default SearchMinCharsHint;
